module.exports = __webpack_public_path__ + "static/media/threat-warning.56a57d07.svg";